<h3-toggle-button-group
  [buttons]="buttons$ | async"
  [ngModel]="redirectShortcutsTo$ | async"
  (ngModelChange)="onRedirectToPointCloudToggle($event)"
></h3-toggle-button-group>
